<section>
    <app-shared-loading *ngIf="loading"></app-shared-loading>
    <div class="general-title">
        <h1 class="pl-1 title">{{ 'cash-Subtitle' | translation | async }}</h1>
    </div>
    <app-return-methods [itsMobileCtrl]="true" [unique]="this.transaction.ORDER_METHOD" (RT)="changeMethod()">
    </app-return-methods>

    <div class="contentBox">
        <div class="center col-3">
            <div class="info-logo-container">
                <img [src]="information.logo" class="payment_method_no_interactive __method_brands"
                    alt="split-payment-logo" />
            </div>
        </div>
        <div class="col-7">
            <div class="methodInfo">
                <app-return-methods [itsMobileCtrl]="false" [unique]="this.transaction.ORDER_METHOD"
                    (RT)="changeMethod()">
                </app-return-methods>
                <h1>{{ 'transferTitle' | translation | async }}</h1>
                <app-payment-expiration [expiration]="transaction.EXPIRATION"></app-payment-expiration>
                <span class="split-title" [ngClass]="{'splitStepTwo': infoLinksTemplate}">{{ stepsMessage | translation |
                    async }}</span>
                <ng-container *ngIf="!infoLinksTemplate; else stepOrderInfo">
                    <form class="splitForm" [formGroup]="splitForm">
                        <div class="containerFirstPayValue">
                            <mat-form-field appearance="outline">
                                <mat-label>{{ 'split-First-Payment-Value' | translation | async }}</mat-label>
                                <mat-icon matPrefix class="icon-amount">{{ defaultCurrency }}</mat-icon>
                                <input matInput id="visualfirstPayValue" name="firstPayValue"
                                    formControlName="firstPayValue" [(ngModel)]="firstPayValue"
                                    (keyup)="validateLimitInputs('firstPayValue')" (ngModelChange)="updateSecondValue()"
                                    placeholder="{{ 'split-First-Payment-Value' | translation | async }}" />
                            </mat-form-field>
                            <p>
                                {{ 'split-Tooltip-Description' | translation | async }}
                            </p>
                        </div>
                        <ng-container *ngFor="let validation of errorsMessages.firstPayValue">
                            <div class="error-message" *ngIf="splitForm.get('firstPayValue').hasError(validation.type) &&
                                        (splitForm.get('firstPayValue').dirty || 
                                        splitForm.get('firstPayValue').touched)">
                                {{ validation.message }}
                            </div>
                        </ng-container>
                        <div class="error-message" *ngIf="splitErrorInput">
                            {{ splitErrorMessage | translation | async }}
                        </div>
                        <mat-form-field appearance="outline">
                            <mat-label>{{ 'split-Second-Payment-Value' | translation | async }}</mat-label>
                            <mat-icon matPrefix class="icon-amount">{{ defaultCurrency }}</mat-icon>
                            <input matInput id="secondPayValue" name="secondPayValue" formControlName="secondPayValue"
                                id="secondPayValue" [(ngModel)]="secondPayValue" />
                        </mat-form-field>
                    </form>
                </ng-container>
                <ng-template #stepOrderInfo>
                    <app-info-order-link [paymentList]="paymentList" [currency]="defaultCurrency" ></app-info-order-link>
                </ng-template>
            </div>
            <!-- Form button -->
            <app-buttons-bar *ngIf="!infoLinksTemplate"
                [valid]="splitForm.valid && !splitErrorInput && (orderAmountTemp - firstPayValue - secondPayValue) >= 0"
                [template]="template" [nameCustom]="buttonMessage | translation | async" class="payButton" (CUSTOM)="generatePayment()">
            </app-buttons-bar>
        </div>
    </div>
</section>